module.exports = __webpack_public_path__ + "img/yellow-line.f3221c4b.svg";